export default __webpack_public_path__ + "static/media/kahsh36mobile.370424b5.png";